import ConfirmationModalExtended from "~/common/components/ConfirmationModalExtended";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { getCookie, setCookie } from "~/common/utils/cookie";
import { isUnsupportedBrowser } from "~/common/utils/browserChecks";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const BROWSER_NOT_SUPPORTED_COOKIE = "browserNotSupported";

export const BrowserNotSupportedPopup = () => {
  const { t } = useTranslation();
  const browserCookie = getCookie(BROWSER_NOT_SUPPORTED_COOKIE);
  const { setFalse: closePopup, val: isModalOpen } = useBooleanState(isUnsupportedBrowser && !browserCookie);

  const onClick = () => {
    closePopup();
    setCookie({
      name: BROWSER_NOT_SUPPORTED_COOKIE,
      value: "true", // the value here is not that important, i need only to set a cookie
      expireDate: dayjs().add(1, "w").toDate(), // expires in 1 week from NOW
    });
  };

  return (
    <div className={"scha__browser-not-supported-popup"}>
      {isModalOpen && (
        <ConfirmationModalExtended okLabel={t("generic.ok")} onOk={onClick} onClose={onClick}>
          <div className={"scha__browser-not-supported-popup__modal"}>
            <h5 className={"scha__browser-not-supported-popup__modal__title title-medium"}>
              {t("browserNotSupported.popup.title")}
            </h5>
            <p className={"scha__browser-not-supported-popup__modal__content mb-30"}>
              {t("browserNotSupported.popup.message")}
            </p>
          </div>
        </ConfirmationModalExtended>
      )}
    </div>
  );
};
